import { Component, OnInit } from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';

@Component({
  selector: 'app-camp-overrided-config',
  templateUrl: './camp-overrided-config.component.html',
  styleUrls: ['./camp-overrided-config.component.scss']
})
export class CampOverridedConfigComponent extends ModalExtended implements OnInit {

    data: Object;

    constructor() {
        super();
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/modals/camp-overrided-config/camp-overrided-config.component.ts